import { FormControl, HFlow, VFlow } from 'bold-ui'
import { ErrorField } from 'components/form/final-form/ErrorField'
import { RadioField } from 'components/form/final-form/RadioField'
import { TipoAtendimentoEnum } from 'graphql/types.generated'
import React from 'react'
import { Meta } from 'util/metaPath'

export interface TipoAtendimentoPanelProps {
  name: Meta<TipoAtendimentoEnum>
  isDemandaEspontanea: boolean
}

export function TipoAtendimentoPanel(props: TipoAtendimentoPanelProps) {
  const { name, isDemandaEspontanea } = props

  return (
    <FormControl label='Tipo de atendimento' required>
      <VFlow vSpacing={0.5}>
        <ErrorField name={name} />

        <HFlow style={{ marginLeft: '-0.25rem' }}>
          {isDemandaEspontanea && (
            <>
              <RadioField name={name} label='Consulta no dia' value={TipoAtendimentoEnum.CONSULTA_NO_DIA} />
              <RadioField name={name} label='Urgência' value={TipoAtendimentoEnum.URGENCIA} />
            </>
          )}
          {!isDemandaEspontanea && (
            <>
              <RadioField name={name} label='Consulta' value={TipoAtendimentoEnum.CONSULTA} />
              <RadioField
                name={name}
                label='Consulta agendada / cuidado continuado'
                value={TipoAtendimentoEnum.CONSULTA_AGENDADA_CUIDADO_CONTINUADO}
              />
            </>
          )}
        </HFlow>
      </VFlow>
    </FormControl>
  )
}
